import script from "./AddProgramPop.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProgramPop.vue?vue&type=script&setup=true&lang=js"

import "./AddProgramPop.vue?vue&type=style&index=0&id=7c38728c&lang=scss"

const __exports__ = script;

export default __exports__